import React from "react";
import { useTranslation } from "react-i18next";
import { Results, withSearch } from "@elastic/react-search-ui";
import { getConfig } from "../../../config/faq-config-helper";
import appConfig from "../../../../config";
import ResultsView from "./ResultsView";
import MetadataLabel from "./MetadataLabel";
import {
  changeEmToMark,
  markMatchedWords,
} from "../../../../helpers/view-helpers";

const ListItem = withSearch(({ searchTerm }) => ({ searchTerm }))(
  ({
    result,
    onClickLink,
    titleField,
    urlField,
    thumbnailField,
    searchTerm,
    ...rest
  }) => {
    const { t } = useTranslation();

    const fileFormat = result?.file_format?.raw || "";
    const nodeUrl = result?.url?.raw || "";
    const fileUrl = appConfig.assetPathTemplate.replace(
      "{node}",
      result?.drupal_node_id?.raw || "",
    );
    const contentUrl = fileFormat === "PDF" ? fileUrl : nodeUrl;
    // field_is_membership_only is text field, so we need to convert it to boolean.
    const isMembershipOnly =
      (result?.field_is_membership_only?.raw || "false") === "true";
    const thumbnailText = markMatchedWords(
      searchTerm,
      result?.field_thumbnail_text?.raw || "",
    );
    const titleText = markMatchedWords(
      searchTerm,
      result?.[titleField]?.raw || "",
    );
    return (
      <div>
        <div className="u-flex u-flex--baseline">
          <div
            className="p-result__category"
            data-category={fileFormat.toLowerCase()}
          >
            {fileFormat}
          </div>
          {/* TODO: Form breadcrumb using API response */}
          {/* <ul className="p-result__layer">
          <li>
            <a href="">TOP &amp;</a> {">"}
            <a href="">News&amp;Info&amp;</a> {">"}
            <a href="">製品</a>
          </li>
        </ul> */}
        </div>
        <p className="p-result__title">
          <a
            href={contentUrl}
            target={fileFormat === "PDF" ? "_blank" : ""}
            dangerouslySetInnerHTML={{ __html: titleText }}
          ></a>
          {isMembershipOnly && (
            <MetadataLabel labelText={t("Membership Only")} />
          )}
        </p>
        <p
          className="u-font--s"
          dangerouslySetInnerHTML={{ __html: thumbnailText }}
        />
        {/* {thumbnailText}
      </p> */}
      </div>
    );
  },
);

const ResultsViewFn = (props) => <ListItem {...props} />;
const OmronResults = () => {
  return (
    <Results
      resultView={ResultsViewFn}
      titleField={getConfig().faqTitleField}
      urlField={getConfig().urlField}
      view={ResultsView}
    />
  );
};

export default OmronResults;
